export const createLead = ({email, name, vars}) => {
    return {
        email:email,
        name: name,
        vars: vars
    }
}


// WEBPACK FOOTER //
// ./src/platform/notifications/leads/factory/leadFactory.js